import { NavLink, Link } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";
import { useState } from "react";
import GovernanceCue from "./GovernanceCue";

export default function AdminShell({ kind, user, nav, children, onLogout }) {
  const [open, setOpen] = useState(false);
  const operator = kind === "platform";
  return (
    <div className="app-shell" data-testid={operator ? "platform-console" : "tenant-console"}>
      <aside className={open ? "sidebar open" : "sidebar"}>
        <div className="side-top">
          <div className="brand-mark">YUG<span>360</span><small>— ADMIN</small></div>
          <button data-testid="sidebar-close-button" className="icon-button mobile-only" onClick={() => setOpen(false)}><X size={18} /></button>
        </div>
        <div className="tenant-switcher" data-testid="admin-context">
          <span className="tenant-dot" />
          <div>
            <strong>{operator ? "NextProMind" : (user?.tenant || "NRG-01")}</strong>
            <small>{operator ? "Platform Admin Console" : "Customer Admin Console"}</small>
          </div>
        </div>
        <nav>
          {(nav || []).map((item) => (
            <NavLink
              key={item.id}
              data-testid={`admin-nav-${item.id}`}
              to={item.route}
              end={item.route.split("/").length <= 3}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
            >
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="side-bottom">
          {!operator && (
            <Link data-testid="open-governed-workspace" className="tour-launcher" to="/" onClick={() => setOpen(false)}>
              Open governed workspace
            </Link>
          )}
          <div className="system-state">
            <span className="status-dot" /> Control plane · one portal, two consoles
            <small>Data plane stays tenant-scoped · Model=None</small>
          </div>
          <button data-testid="logout-button" className="logout-button" onClick={onLogout}><LogOut size={15} /> Sign out</button>
        </div>
      </aside>
      <div className="main-area">
        <header className="topbar">
          <button data-testid="mobile-menu-button" className="icon-button mobile-only" onClick={() => setOpen(true)}><Menu size={20} /></button>
          <div className="crumb">
            <span className="sample-pill">{operator ? "PLATFORM CONSOLE" : "TENANT CONSOLE"}</span>
            <strong>{operator ? "YUG360-MIND operator" : "Northstar Retail Group"}</strong>
          </div>
          <div className="top-actions">
            <div className="user-chip" data-testid="current-user">
              <span className="avatar">{(user?.name || "?").split(" ").map((w) => w[0]).join("").slice(0, 2)}</span>
              <span>{user?.name}<small>{user?.role}</small></span>
            </div>
            <button data-testid="logout-button-topbar" className="logout-button" type="button" onClick={onLogout}>
              <LogOut size={15} /> Sign out
            </button>
          </div>
        </header>
        <div className="page-content">
          <GovernanceCue guide={user?.guide} />
          {children}
        </div>
      </div>
    </div>
  );
}
